/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="25" height="19" viewBox="0 0 25 19" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <path fill="#4A4A4A" d="M19.335.957a1.208 1.208 0 0 0 .037 1.744A9.636 9.636 0 0 1 22.167 9.5a9.636 9.636 0 0 1-2.832 6.834 1.208 1.208 0 0 0 1.709 1.71 12.045 12.045 0 0 0 3.54-8.544c0-3.337-1.353-6.358-3.54-8.544a1.208 1.208 0 0 0-1.709 0Z" className="icon-fill"/>
        <path fill="#4A4A4A" d="M19.75 9.5a7.228 7.228 0 0 1-2.123 5.127l-.001-.001a1.208 1.208 0 1 1-1.673-1.743 4.818 4.818 0 0 0 1.38-3.383 4.818 4.818 0 0 0-1.416-3.416 1.208 1.208 0 0 1 1.709-1.71A7.228 7.228 0 0 1 19.75 9.5ZM1.625 4.667c-.667 0-1.208.54-1.208 1.208v7.25c0 .667.541 1.208 1.208 1.208h4.41c.274 0 .54.094.755.265l3.747 2.998c.791.633 1.963.07 1.963-.943V2.347c0-1.013-1.172-1.576-1.963-.943L6.79 4.402c-.215.171-.48.265-.755.265h-4.41Z" className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'AudioIcon';

export default Icon;
